// --------------------------------------------------------
// src/collections/theme.collection.js
//
// Ordered sets of Theme models.
//
// --------------------------------------------------------
"use strict";

const ThemeCollection = Backbone.Collection.extend({
    
    model: ThemeModel,

	// Shuffle the collection
	randomize: function() {
        var themes = this.shuffle();

        return new ThemeCollection(themes);
	}

});
